var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChatEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.75L20 20.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2803 18.5303C21.421 18.3897 21.5 18.1989 21.5 18V6C21.5 5.80109 21.421 5.61032 21.2803 5.46967C21.1397 5.32902 20.9489 5.25 20.75 5.25H9.5M18.2421 18.75H8.23426C8.0577 18.75 7.8868 18.8123 7.75165 18.9259L4.73261 21.4638C4.62328 21.5557 4.48999 21.6145 4.3484 21.6332C4.20681 21.652 4.06281 21.6299 3.93334 21.5696C3.80387 21.5093 3.69431 21.4133 3.61755 21.2928C3.54078 21.1724 3.5 21.0325 3.5 20.8897V6C3.5 5.80109 3.57902 5.61032 3.71967 5.46967C3.86032 5.32902 4.05109 5.25 4.25 5.25H5.9375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatEnd);
export default __webpack_public_path__ + "static/media/icon-chat-end.4a8e4e06345da68b42df1aafde7a9c8b.svg";
export { ForwardRef as ReactComponent };